const i18n = {
	parseFormat:"%Y-%m-%d %H:%i",
	parseTimeFormat:"%H:%i",
};


export default i18n;